import { API, DASHBOARD_API } from '../Utils/API'
import { useLoader } from '../Utils/LoaderContext'

export const useDashboard = () => {

    const { showLoader, hideLoader } = useLoader()

    const getCounts = async () => {
        showLoader()
        const res = await API.post(DASHBOARD_API.GET_COUNTS);
        hideLoader();
        return res;
    }

    const getChartData = async () => {
        showLoader()
        const res = await API.post(DASHBOARD_API.GET_CHART_DATA);
        hideLoader();
        return res;
    }

    const reasonToDelete = async () => {
        showLoader()
        const res = await API.post(DASHBOARD_API.REASON_TO_DELETE);
        hideLoader();
        return res;
    }

    const searchEventsByLocation = async (location) => {
    try {
      showLoader();
      const res = await API.post( DASHBOARD_API .GET_EVENTS_BY_LOCATION, {
        location: location.trim(),
      });
      hideLoader();
      return res;
    } catch (error) {
      hideLoader();
      console.error("Error fetching events by location:", error);
      throw error; // Handle error as needed
    }
  };

   
  const searchUserByLocation = async(location) => {
    try{
     showLoader()
    const res = await API.post( DASHBOARD_API .GET_USER_BY_LOCATION, {
        location: location.trim(),
      });
      hideLoader();
      return res;
    }catch(error) {
      hideLoader()
      console.log("Error fetching users by loacation:", error)
       throw error; // Handle error as needed
    }
  }
    return { getCounts, getChartData, reasonToDelete, searchEventsByLocation, searchUserByLocation }
}
